module.exports = __webpack_public_path__ + "static/receipts-mobile-59ccfc878ed65a9fe945c941bea4bd53.png";